import { API_BASE } from "./api";

/**
 * Fire-and-forget click tracking. Uses sendBeacon when available so the
 * outbound navigation is not delayed by the tracking request.
 */
export function trackEvent(payload) {
  try {
    const body = JSON.stringify({
      ...payload,
      landing_url: typeof window !== "undefined" ? window.location.href : undefined,
      referrer_path: typeof window !== "undefined" ? window.location.pathname : undefined,
    });
    const url = `${API_BASE}/tracking/event`;
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
    } else {
      fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
    }
  } catch (err) {
    // never block navigation on tracking error
    if (typeof process !== "undefined" && process.env?.NODE_ENV !== "production") {
      console.warn("trackEvent failed:", err?.message || err);
    }
  }
}
